let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bckKi")).then(() => parcelRequire('ee5d3'));